const React = require('react');
const PropTypes = require('prop-types');
import { formatText } from 'core/i18n';
import { RadioButton } from 'components/RadioButton/RadioButton';
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const formActions = require('react-redux-form').actions;
const optionsActions = require('actions/optionsActions');
const focusActions = require('actions/focusActions');
const stepsActions = require('actions/stepsActions');
const standByActions = require('actions/standByActions');
import { ONB_BANK_DEPOSIT_OPEN } from 'constants/onboardingTypes';
import { TRADITIONAL } from 'constants/userProfile';

import { recordEvent } from 'utilities/uTagging';

class JointHolderDecision extends React.Component {
    constructor(props) {
        super(props);

        this.handleOnDelete = this.handleOnDelete.bind(this);
    }

    handleOnDelete() {
        const { userProfile, formActions } = this.props;
        const count = userProfile.jointHolderCount;

        if (count) {
            for (let i = 0, len = count.length; i < len; i++) {
                const id = i + 1;
                const index = userProfile['jointHolderCount'].indexOf(i);
                formActions.remove('userProfile.jointHolderCount', index);
                formActions.remove('userProfile.jointHolderIsEditing', index);
                formActions.change(`userProfile.jointholder_${id}_name`, '');
                formActions.change(`userProfile.jointholder_${id}_lastName`, '');
                formActions.change(`userProfile.jointholder_${id}_secondLastName`, '');
                formActions.change(`userProfile.jointholder_${id}_documentType`, '');
                formActions.change(`userProfile.jointholder_${id}_docNumber`, '');
                formActions.change(`userProfile.jointholder_${id}_accountType`, '');
                formActions.change(`userProfile.jointholder_${id}_email`, '');
            }
            formActions.change('userProfile.jointHolderCount', [2]);
            formActions.change('userProfile.jointHolderEditable', 2);
            formActions.change('userProfile.jointHoldersError', false);
        }
    }

    render() {
        const { userProfile } = this.props;
        const handleSave = this.props.handleSave;
        const jointHolderDecisionDisabled = userProfile.jointHolderDecisionDisabled;
        const disabled = jointHolderDecisionDisabled ? true : this.props.immStepsState.get('readOnlyForms');
        const isDeposit =
            userProfile.investmentType === TRADITIONAL && userProfile.onboardingType === ONB_BANK_DEPOSIT_OPEN;

        const handleDelete = this.handleOnDelete;
        const decisionLabelText = isDeposit
            ? 'field-jointHolderDecisionQuestionDeposit'
            : 'field-jointHolderDecisionQuestion';

        return (
            <div className="md-form-group form__input">
                <label className="_radio-label">{formatText(decisionLabelText)}</label>
                <div className="joint-holders-decision">
                    <p className="font-paragraph2">{formatText('field-jointHolderDecisionParagraph')}</p>
                </div>
                <RadioButton
                    profileModel="userProfile.jointHolderDecision"
                    optionsList={[
                        {
                            label: formatText('field-addJointHolderTrue'),
                            value: true,
                        },
                        {
                            label: formatText('field-addJointHolderFalse'),
                            value: false,
                        },
                    ]}
                    isRequired
                    isUpdated={function () {
                        handleSave('jointHolderDecision', userProfile.jointHolderDecision);
                        recordEvent(
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            userProfile.investmentType,
                            undefined,
                            {
                                categoriaEvento: 'eventos onboarding',
                                accionEvento: 'intervinientes',
                                etiquetaEvento: userProfile.jointHolderDecision === 'true' ? 'si' : 'no',
                            }
                        );
                        if (userProfile.jointHolderDecision === 'false') {
                            handleDelete();
                        }
                    }}
                    disabled={disabled}
                    messagesError={{ required: formatText('validation-radioRequired') }}
                    {...this.props}
                />
            </div>
        );
    }
}

JointHolderDecision.propTypes = {
    handleSave: PropTypes.func,
    userProfile: PropTypes.object,
    formActions: PropTypes.object,
    immStepsState: PropTypes.object,
};

module.exports.JointHolderDecision = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        focus: state.focus,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        focusActions: bindActionCreators(focusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
    })
)(JointHolderDecision);
